import { useState, useRef } from "react";
import { useDispatch } from "react-redux";

import axios from "axios";

import {
  showDangerAlert,
  showSuccessAlert,
} from "../redux/actions/alert/alertActions";

const useAxios = ({
  baseURL,
  url,
  method = "get",
  payload,
  params,
  showSuccess,
  showError,
  successMessage,
  errorMessage,
  config,
}) => {
  const dispatch = useDispatch();
  const [fetchDetail, setFetchDetail] = useState({
    isLoading: false,
    isLoaded: false,
    error: null,
    data: null,
  });

  const handleAlert = (message, type) => {
    switch (type) {
      case "success":
        dispatch(showSuccessAlert(message));
        break;
      case "error":
        dispatch(showDangerAlert(message));
    }
  };

  const controllerRef = useRef(new AbortController());
  const cancel = () => {
    controllerRef.current.abort();
  };

  const fetch = (data, dataParams, urlEndPoint) => {
    return new Promise((resolve, rejects) => {
      axios
        .request({
          data: data || payload,
          signal: controllerRef.current.signal,
          method,
          baseURL,
          url: urlEndPoint || url,
          params: dataParams || params,
          ...config,
        })
        .then(resolve)
        .catch(rejects);
    });
  };

  const run = (data, dataParams, urlEndPoint) => {
    return new Promise((resolve, reject) => {
      setFetchDetail({ ...fetchDetail, isLoading: true });
      fetch(data, dataParams, urlEndPoint)
        .then((response) => {
          setFetchDetail({
            ...fetchDetail,
            isLoaded: true,
            isLoading: false,
            data: response.data,
            error: null,
          });
          if (showSuccess)
            handleAlert(successMessage || response?.message, "success");
          resolve(response);
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            setFetchDetail({
              ...fetchDetail,
              isLoaded: true,
              isLoading: false,
              error: error.response?.data,
            });
            if (showError) handleAlert(errorMessage || error?.message, "error");
            reject(error);
          }
        });
    });
  };

  return {
    cancel,
    data: fetchDetail.data,
    error: fetchDetail.error,
    isLoaded: fetchDetail.isLoaded,
    isLoading: fetchDetail.isLoading,
    run,
  };
};

export default useAxios;
